import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const serviceDetail_API = "/serviceDetail";

// ----------------------- STATE ------------------------- //
const state = {
  serviceDetail_data: [],
  currentIndex: 0
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getserviceDetail: state =>
    getField(state.serviceDetail_data[state.currentIndex]),

  getCurrentserviceDetail: state => {
    return state.serviceDetail_data[state.currentIndex];
  },

  getTotalLabour: state => {
    let totalLabour = 0;
    state.serviceDetail_data.forEach(item => {
      totalLabour += item.labour;
    });

    return totalLabour;
  },

  getTotalParts: state => {
    let totalParts = 0;
    state.serviceDetail_data.forEach(item => {
      totalParts += item.parts;
    });

    return totalParts;
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateserviceDetail(state, payload) {
    updateField(state.serviceDetail_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.serviceDetail_data.findIndex(
      serviceDetail => serviceDetail.id == theID
    );
  },

  loadAllserviceDetails(state, payload) {
    state.serviceDetail_data = payload.data;
    state.currentIndex = 0;
  },

  addserviceDetail(state, payload) {
    state.serviceDetail_data.push(payload.data);
    state.currentIndex = state.serviceDetail_data.length - 1;
  },

  saveserviceDetail(state, payload) {
    state.serviceDetail_data[state.currentIndex] = payload.data;
  },

  fetchserviceDetail(state, payload) {
    if (state.currentIndex == -1) {
      state.serviceDetail_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.serviceDetail_data[state.currentIndex] = payload.data;
    }
  },

  deleteserviceDetail(state, payload) {
    state.currentIndex = state.serviceDetail_data.findIndex(
      serviceDetail => serviceDetail.id == payload.data.id
    );
    state.serviceDetail_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.serviceDetail_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllserviceDetails({ commit }) {
    try {
      commit(
        "loadAllserviceDetails",
        await Repository.get(`${serviceDetail_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addserviceDetail({ commit }) {
    await Repository.get(`${serviceDetail_API}/new`)
      .then(response => {
        commit("addserviceDetail", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveserviceDetail({ state, commit }) {
    try {
      commit(
        "saveserviceDetail",
        await Repository.post(
          `${serviceDetail_API}`,
          state.serviceDetail_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchserviceDetail({ commit }, payloadID) {
    try {
      commit(
        "fetchserviceDetail",
        await Repository.get(`${serviceDetail_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteserviceDetail({ commit }, payloadID) {
    try {
      commit(
        "deleteserviceDetail",
        await Repository.delete(`${serviceDetail_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchserviceDetails({ commit }, searchTerm) {
    try {
      commit(
        "loadAllserviceDetails",
        await Repository.get(`${serviceDetail_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
